__turbopack_context__.v({
  "loading": "SubmitButton-module__n3d1DG__loading",
});
